module.exports = __webpack_public_path__ + "static/media/NC.82f24d24.svg";